import {
  Routes, //replaces "Switch" used till v5
  Route,
} from "react-router-dom";

import { Home, Jornada1, Jornada2, Jornada3 } from "./components";
const MainNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<Home is2026 showPresentacion />} />
      <Route path="/inicio" element={<Home is2026 showPresentacion />} />
      <Route path="/2022" element={<Jornada1 />} />
      <Route path="/2024" element={<Jornada2 />} />
      <Route path="/2026" element={<Jornada3 />} />
      <Route path="*" element={<Home is2026 showPresentacion />} />
    </Routes>
  );
};

export default MainNavigation;
